module.exports = {
  i18n: {
    debug: false,
    defaultLocale: 'en',
    locales: ['default', 'en', 'de'],
  },
}
